<template>
  <div class="edit-order-person rj-page-card" style="min-height: 150px">
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                姓名:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.userName }}
              </div>
            </div>
          </div>
          <template>
            <div v-for="(propItem,index) in form.addPersonList" :key="index" class="for-add-person">
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    区域:<span class="required">*</span> ：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item
                      :prop="'addPersonList.'+ index + '.areaName'"
                      :rules="rules.areaName"
                    >
                      <el-select
                        v-model="propItem.areaName"
                        filterable
                        remote
                        placeholder="请输入所在地区"
                        :remote-method="getAreaOptions"
                        :loading="loading"
                        @change="selectFindID(index,1)"
                      >
                        <el-option
                          v-for="item in areaOptions"
                          :key="item.areaID"
                          :label="item.areaName"
                          :value="item.areaName"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    部门:<span class="required">*</span> ：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item
                      :prop="'addPersonList.'+ index + '.deptName'"
                      :rules="rules.deptName"
                    >
                      <el-select
                        v-model="propItem.deptName"
                        filterable
                        remote
                        placeholder="请输入所在部门"
                        :remote-method="getDepartOptions"
                        :loading="loading"
                        @change="selectFindID(index,2)"
                      >
                        <el-option
                          v-for="item in departOptions"
                          :key="item.deptCode"
                          :label="item.deptName"
                          :value="item.deptName"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="rj-col-3">
                <div class="rj-baseinfo">
                  <div class="rj-baseinfo__label">
                    类型:<span class="required">*</span> ：
                  </div>
                  <div class="rj-baseinfo__item">
                    <el-form-item
                      :prop="'addPersonList.'+ index + '.privilegeType'"
                      :rules="rules.privilegeType"
                    >
                      <el-select v-model="propItem.privilegeType" clearable placeholder="请选择">
                        <el-option
                          v-for="item in typeOptionsList"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictLabel"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="add-person-ass">
                <el-button type="text" @click="addParsonListFor">
                  添 加
                </el-button>
                <el-button v-if="index !== 0" type="text" @click="removeParsonListFor(index)">
                  删 除
                </el-button>
              </div>
            </div>
          </template>
          <!-- <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                所在地区:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="areaName">
                  <el-select
                    v-model="form.areaName"
                    filterable
                    remote
                    placeholder="请输入所在地区"
                    :remote-method="getAreaOptions"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in areaOptions"
                      :key="item.saleAreaID"
                      :label="item.saleAreaName"
                      :value="item.saleAreaName"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                所在部门:<span class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="deptName">
                  <el-select
                    v-model="form.deptName"
                    filterable
                    remote
                    placeholder="请输入所在部门"
                    :remote-method="getDepartOptions"
                  >
                    <el-option
                      v-for="item in departOptions"
                      :key="item.deptCode"
                      :label="item.deptName"
                      :value="item.deptName"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div> -->
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updateInfo } from '@/API/index.js';
export default {
  name: 'EditNewOrderPerson',
  data () {
    return {
      form: {
        userId: '',
        userName: '',
        deptCode: '',
        deptName: '',
        areaId: '',
        areaName: '',
        addPersonList: [{
          areaName: '',
          deptName: '',
          privilegeType: ''
        }]
      },
      rules: {
        deptName: [
          { required: true, message: '请输入所在部门', trigger: 'change' }
        ],
        areaName: [
          { required: true, message: '请输入所在地区', trigger: 'change' }
        ],
        privilegeType: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ]
      }
    };
  },
  props: {
    editForm: {
      type: Object,
      default: () => ({})
    },
    orderPersonList: {
      type: Array,
      default: () => { return {}; }
    },
    departOptions: {
      type: Array,
      default: () => { return {}; }
    },
    areaOptions: {
      type: Array,
      default: () => { return {}; }
    },
    loading: {
      type: Boolean,
      default: false
    },
    typeOptionsList: {
      type: Array,
      default: () => { return {}; }
    }
  },
  mounted () {
    this.form = this.editForm;
    this.$set(this.form, 'addPersonList', [{
      areaName: '',
      deptName: '',
      privilegeType: ''
    }]);
  },
  methods: {
    getDepartOptions (query) {
      this.$emit('DepartOptions', query);
    },
    getAreaOptions (query) {
      this.$emit('AreaOptions', query);
    },
    addParsonListFor () {
      let defaultItem = {
        areaName: '',
        deptName: '',
        privilegeType: ''
      };
      this.form.addPersonList.push(defaultItem);
      console.log(this.form);
    },
    removeParsonListFor (i) {
      this.form.addPersonList.splice(i, 1);
    },
    selectFindID (i, val) {
      if (val === 1) {
        this.form.addPersonList[i].areaId = this.selectNameSeachId(this.areaOptions, 'areaName', this.form.addPersonList[i].areaName, 'areaId');
      }
      if (val === 2) {
        this.form.addPersonList[i].deptCode = this.selectNameSeachId(this.departOptions, 'deptName', this.form.addPersonList[i].deptName, 'deptCode');
      }
    },
    // 判断区域+部门名称不可重复
    checkAreaDeptName (i) {
      let arr = [];
      this.form.addPersonList.forEach(item => {
        arr.push(item.areaName + item.deptName);
      });
      console.log(arr);
      return this.hasDuplicates(arr);
    },
    hasDuplicates (array) {
      return new Set(array).size !== array.length;
    },
    submitEditOrderPerson () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.checkAreaDeptName()) {
            this.$message.warning('区域+部门名称不可重复');
            return false;
          }
          const showName = this.form.userName;
          const showId = this.form.userId;
          let params = JSON.parse(JSON.stringify(this.form.addPersonList));
          params.forEach((item, index) => {
            if (index !== 0) {
              item.userName = showName;
              item.userId = showId;
            }
          });
          updateInfo(params).then((res) => {
            let json = res.data;
            if (json.status === '200') {
              this.$message.success('添加成功');
              this.$emit('isShowEdit', false);
            }
          }).catch((res) => {
            this.$message.warning('添加失败');
            this.$emit('isShowEdit', false);
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 获取select列表id值
     * @param {Array} arr - 要搜索的数组
     * @param {string} arrName - 要搜索的数组的属性名
     * @param {string} name - 要搜索的值
     * @param {string} arrVal - 查询列表对应的值
     * @returns {string} val - 搜索到的值
     */
    selectNameSeachId (arr, arrName, name, arrVal) {
      let val;
      if (arr.length > 0) {
        arr.forEach((item) => {
          if (item[arrName] === name) {
            val = item[arrVal];
          }
        });
        return val;
      }
    }
  }
};
</script>

<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
  .edit-order-person{
    .rj-col-1,.rj-col-3{
      margin-bottom: 10px;
    }
    .el-select{
      width: 10rem;
    }
    .rj-col-3{
      float: left;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 30%;
    }
    .add-person-ass{
      float: left;
      display: inline-block;
      line-height: 40px;
    }
  }
</style>

<style lang="scss">
  .for-add-person{
    .el-form-item__error{
      position: absolute !important;
      top: 100%;
      left: 0;
    }
  }
</style>
